import axios from "axios";

var config = require('../config/appConfig');

export default function multiplePostRequests(urls, headers, data) {
    let requests = [];
    for(let i = 0; i < urls.length; i++) {
        requests.push(
            axios.post(config.serverUrl+urls[i], data,{
                withCredentials: true,
                credentials: "include",
                headers:headers,
            })
        )
    }
    return axios.all(requests).then(axios.spread((...responses) => {
        return responses;
    })).catch(error => {
        if (error && error.response && error.response.status) {
            return error.response.status;
        }
    });
}

